<div class="modal-body">
  <p class="centermodal__title">{{ 'documents.' + (isNewDocument ? 'archiveIn' : 'archive') | translate }}</p>

  <div class="folder__selection">
    <div class="centermodal__form mb-0">
      <app-search [(query)]="search" theme="clean" (queryChange)="searchFolders({ pageNumber: 1, search: search })" #searchComponent></app-search>
    </div>

    @if (parentFolder) {
      <button class="btn-S btn-filled-cancel icon-start my-1 mr-auto" (click)="selectFolder(parentFolder.parentFolder || undefined)">
        <i class="far fa-chevron-left"></i>
        {{ 'button.back' | translate }}
      </button>
    }

    <ul class="centermodal__item-list">
      @if (!isLoading && !parentFolder && !search && folders && folders.length > 0) {
        <li class="centermodal__item centermodal__item--none" [class.active]="selectedFolder === null" (click)="selectFolder(null)">
          <i class="far fa-lg fa-folder-xmark"></i> {{ 'documents.noFolder' | translate }}
        </li>
      }
      @if (parentFolder) {
        <li class="centermodal__item" [class.active]="selectedFolder?.id === parentFolder.id" (click)="selectFolder(parentFolder, true)">
          <i class="far fa-lg fa-folders"></i> {{ parentFolder.name }}
        </li>
      }
      @for (folder of folders; track $index) {
        <li class="centermodal__item" [class.ml-4]="parentFolder" [class.active]="selectedFolder?.id === folder.id" (click)="selectFolder(folder)">
          <i class="far fa-lg fa-{{ folder.children_counter > 0 ? 'folders' : 'folder' }}"></i> {{ folder.name }}
          @if (folder.children_counter > 0) {
            <span class="folder-count">{{ folder.children_counter > 99 ? '99+' : folder.children_counter }}</span>
          }
        </li>
      }
    </ul>

    @if (isLoading && (!folders || folders.length === 0)) {
      <app-small-loader></app-small-loader>
    }

    @if (!isLoading && folders && folders.length === 0) {
      <div class="centermodal__form empty-warning">{{ 'documents.noFoldersFound' | translate }}</div>
    }

    @if (!isLastPage && !isLoading) {
      <button type="button" class="btn-M btn-text d-flex mx-auto mt-1" (click)="searchFolders({ search: search, pageNumber: pageNumber + 1 })">{{ 'button.loadMore' | translate }}</button>
    }
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <div class="centermodal__button-group">
      @if (!isNewDocument) {
        <button type="button" class="btn-M btn-outline mr-2" [disabled]="isLoading" (click)="openCreateFolderModal()">
          {{ 'menu.newFolder' | translate }}
        </button>
        <button type="button" class="btn-M btn-filled" [disabled]="isLoading || selectedFolder === undefined" (click)="moveToFolder(selectedFolder)">
          {{ 'documents.' + (selectedFolder === null ? 'unarchive' : 'archive') | translate }}
        </button>
      } @else {
        <button type="button" class="btn-M btn-filled" [disabled]="isLoading || selectedFolder === undefined" (click)="targetFolder(selectedFolder)">
          {{ 'button.select' | translate }}
        </button>
      }
    </div>
  </div>
</div>
